import { colors } from '../../colors';
var button = {
  //Hero button
  linkColorHero: colors.white,
  linkColorHeroHover: colors.white,
  backgroundColorHero: colors.brightRed,
  backgroundColorHoverHero: colors.cherry,
  borderRadiusHero: '0',
  linkLineHeightHero: '30px',
  heroButtonPadding: '20px 35px',
  //primary button
  linkColorPrimary: colors.white,
  linkColorPrimaryHover: colors.white,
  backgroundColorPrimary: colors.brightRed,
  backgroundColorHoverPrimary: colors.cherry,
  borderRadiusPrimary: '0',
  //secondary button
  linkColorSecondary: colors.black,
  linkColorSecondaryHover: colors.white,
  backgroundColorSecondary: colors.white,
  backgroundColorHoverSecondary: colors.black,
  borderRadiusSecondary: '0',
  borderColorSecondary: colors.black,
  borderColorSecondaryHover: colors.black
};
export default button;